//注意:token直接封装在方法里面 不需要再页面中当参数传   
import store from "@/store";
let token = JSON.parse(window.localStorage.getItem("user"));
import request from "../utils/request.js"

// 请求登录 API 的方法
function findPartyPublicity(
  {
    token, pageNo, pageSize, title, auditStatus, publicityWay, displayTime,
  }
) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("pageNo", pageNo)
  fd.append("pageSize", pageSize)
  if (title != undefined) {
    fd.append("title", title)
  }
  if (auditStatus != undefined) {
    fd.append("auditStatus", auditStatus)
  }
  if (displayTime != undefined) {

    fd.append("displayTime", displayTime)
  }
  if (publicityWay != undefined) {

    fd.append("publicityWay", publicityWay)
  }

  // fd.append("title", title)
  // fd.append("auditStatus", auditStatus)
  // fd.append("publicityWay", publicityWay)
  // fd.append("publicityDate", publicityDate)
  return request({
    url: "/admin/partyPublicity/info/findPartyPublicity",
    method: "POST",
    data: fd,
  });
}
function findPartyPublicityById({ token, id }) {		// 查询党建宣传信息
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id	", id)
  return request({
    url: "/admin/partyPublicity/info/findPartyPublicityById",
    method: "POST",
    data: fd,
  });
}
function insertPartyPublicity({ token, tanchuadd }) {		// 新增党建宣传
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params	", params)
  return request({
    url: "/admin/partyPublicity/info/insertPartyPublicity",
    method: "POST",
    data: fd,
  });
}
function updatePartyPublicity({ token, tanchuaddbj }) {			// 党建宣传编辑
  let params = JSON.stringify(tanchuaddbj);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/admin/partyPublicity/info/updatePartyPublicity",
    method: "POST",
    data: fd,
  });
}
function deletePartyPublicity({ token, id }) {		//  删除党建宣传
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id	", id)
  return request({
    url: "/admin/partyPublicity/info/deletePartyPublicity",
    method: "POST",
    data: fd,
  });
}
// 党建宣传 - 审批
function auditPartyPublicity({ token, shenpi }) {
  let params = JSON.stringify(shenpi);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/admin/partyPublicity/info/auditPartyPublicity",
    method: "POST",
    data: fd,
  });
}
// 党建宣传形式统计
function findPublicityWayStatistics({
  token, pageNo, pageSize, title, auditStatus, publicityWay, displayTime,
}) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("pageNo", pageNo)
  fd.append("pageSize", pageSize)
  if (title != undefined) {
    fd.append("title", title)
  }
  if (auditStatus != undefined) {
    fd.append("auditStatus", auditStatus)
  }
  if (displayTime != undefined) {

    fd.append("displayTime", displayTime)
  }
  if (publicityWay != undefined) {

    fd.append("publicityWay", publicityWay)
  }

  return request({
    url: "/admin/partyPublicity/info/findPublicityWayStatistics",
    method: "POST",
    data: fd,
  });
}
// 阵地建设
// 阵地建设 - 列表
function findPositions(params) {

  return request({
    url: "/djyl/admin/partyOrgBuild/info/positionBuildList",
    method: "POST",
    data: params
  });
}

// 阵地建设 - 查看详情
function findPositionsById({
  token, id,
}) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)
  return request({
    url: "/djyl/admin/positions/info/findPositionsById",
    method: "POST",
    data: fd,
  });
}
// 阵地建设 - 删除
function deletePositions({
  token, id,
}) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)
  return request({
    url: "/admin/positions/info/deletePositions",
    method: "POST",
    data: fd,
  });
}

// 阵地建设 - 审核 
function auditPositions({ token, shenpi }) {
  let params = JSON.stringify(shenpi);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/admin/positions/info/auditPositions",
    method: "POST",
    data: fd,
  });
}
// 阵地建设 - 新增 
function insertPosition({ token, tanchuadd }) {
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/admin/positions/info/insertPositions",
    method: "POST",
    data: fd,
  });
}
// 阵地建设 - 编辑
function updatePositions({ token, tanchuaddck }) {
  let params = JSON.stringify(tanchuaddck);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/djyl/admin/positions/info/updatePositions",
    method: "POST",
    data: fd,
  });
}

// 组织分布  - 树形控件
function OrgTreelist({ token }) {
  let fd = new FormData()
  fd.append("token", token)
  return request({
    url: "/rbac/admin/org/info/OrgTreelist",
    method: "POST",
    data: fd
  });
}
// 组织分布 
function findPositionsByAddress({ token, gridCode, committeeCode, streeCode }) {
  let fd = new FormData()
  fd.append("token", token)
  if (streeCode != null) {
    fd.append("streeCode", streeCode)
  }
  if (committeeCode != null) {
    fd.append("committeeCode", committeeCode)
  }
  if (gridCode != null) {  // 7h2LvycyS-Sr-KZBaWHy-g
    fd.append("gridCode", gridCode)
  }
  return request({
    url: "/admin/positions/info/findPositionsByAddress",
    method: "POST",
    data: fd,
  });
}

//组织生活
// 组织生活列表 /admin/orgLife/info/findOrgLife
function findOrgLife({
  token, pageNo, pageSize, title, auditStatus, createDate, firstType, secondType,orderBy,
}) {
  let fd = new FormData()
  // fd.append("token", token)
  fd.append("pageNo", pageNo)
  fd.append("pageSize", pageSize)
  if (firstType != '') {
    fd.append("firstType", firstType)
  }
  if (secondType != '') {
    fd.append("secondType", secondType)
  }
  if (title != '') {
    fd.append("title", title)
  }
  if (auditStatus != '') {
    fd.append("auditStatus", auditStatus)
  }
  if (createDate != '') {

    fd.append("createDate", createDate)
  }
 

    fd.append("orderBy", orderBy)

  return request({
    url: "/admin/orgLife/info/findOrgLife",
    method: "POST",
    data: fd,
  });
}

// 组织生活 - 上传视频   /controller/uploadVotePic/info/uploadOrgLife
function uploadOrgLife(file) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append('file', file)
  return request({
    url: "/controller/uploadVotePic/info/uploadOrgLife",
    method: "POST",
    data: fd
  });
}
// 组织生活  -  新增
function insertOrgLife({ token, addLife }) {
  let params = JSON.stringify(addLife);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/admin/orgLife/info/insertOrgLife",
    method: "POST",
    data: fd,
  });
};
// 组织生活 - 删除
function deleteOrgLife({ token, id }) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)
  return request({
    url: "/admin/orgLife/info/deleteOrgLife",
    method: "POST",
    data: fd,
  });
};
// 组织生活 - 查看详情
function findOrgLifeById({ token, id }) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)
  return request({
    url: "/admin/orgLife/info/findOrgLifeById",
    method: "POST",
    data: fd,
  });
};
// 组织生活 - 审批
function auditOrgLife({ token, shenpiLife }) {
  let params = JSON.stringify(shenpiLife);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/admin/orgLife/info/auditOrgLife",
    method: "POST",
    data: fd,
  });
};
// 组织生活 - 修改  /admin/orgLife/info/updateOrgLife
function updateOrgLife({ token, editLife }) {
  let params = JSON.stringify(editLife);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/admin/orgLife/info/updateOrgLife",
    method: "POST",
    data: fd,
  });
};
// 组织生活 - 删除参与人员等
function deleteOrgLifePerson({ token, id }) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)
  return request({
    url: "/admin/orgLife/info/deleteOrgLifePerson",
    method: "POST",
    data: fd,
  });
};
// 组织生活 - 学习统计 
function findOrgLifeStatistics({
  token, title, auditStatus, createDate, firstType, secondType
}) {
  let fd = new FormData()
  fd.append("token", token)
  if (firstType != '') {
    fd.append("firstType", firstType)
  }
  if (secondType != '') {
    fd.append("secondType", secondType)
  }
  if (title != '') {
    fd.append("title", title)
  }
  if (auditStatus != '') {
    fd.append("auditStatus", auditStatus)
  }
  if (createDate != '') {

    fd.append("createDate", createDate)
  }
  return request({
    url: "/admin/orgLife/info/findOrgLifeStatistics",
    method: "POST",
    data: fd,
  });
}
// 组织生活 - 统计会议次数  
function findMeetingStatistics({
  token, title, auditStatus, createDate, firstType, secondType, studyTime
}) {
  let fd = new FormData()
  fd.append("token", token)
  if (firstType != '') {
    fd.append("firstType", firstType)
  }
  if (secondType != '') {
    fd.append("secondType", secondType)
  }
  if (title != '') {
    fd.append("title", title)
  }
  if (auditStatus != '') {
    fd.append("auditStatus", auditStatus)
  }
  if (createDate != '') {

    fd.append("createDate", createDate)
  }
  if (studyTime != '') {

    fd.append("studyTime", studyTime)
  }
  return request({
    url: "/admin/orgLife/info/findMeetingStatistics",
    method: "POST",
    data: fd,
  });
}

// 学习教育 - 获取列表   
function findLearnTeach({
  pageNo, pageSize, title, auditStatus, createDate, firstType, secondType
}) {
  let fd = new FormData()
  // fd.append("token", token)
  fd.append("pageNo", pageNo)
  fd.append("pageSize", pageSize)
  if (firstType !== '') {
    fd.append("firstType", firstType)
  }
  if (secondType !== '') {
    fd.append("secondType", secondType)
  }
  if (title != '') {
    fd.append("title", title)
  }
  if (auditStatus !== '') {
    fd.append("auditStatus", auditStatus)
  }
  if (createDate != '') {
    fd.append("createDate", createDate)
  }
  return request({
    url: "/admin/learnTeach/info/findLearnTeach",
    method: "POST",
    data: fd,
  });
}
// 学习教育 - 删除  
function deleteLearnTeach({ token, id }) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)
  return request({
    url: "/admin/learnTeach/info/deleteLearnTeach",
    method: "POST",
    data: fd,
  });
};
// 学习教育 - 新增  
function insertLearnTeach({ token, addLearn }) {
  let fd = new FormData();
  let params = JSON.stringify(addLearn);
  // fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/admin/learnTeach/info/insertLearnTeach",
    method: "POST",
    data: fd,
  });
};
// 学习教育 - 查看详情  
function findLearnTeachById({ token, id }) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)
  return request({
    url: "/admin/learnTeach/info/findLearnTeachById",
    method: "POST",
    data: fd,
  });
};
// 学习教育 - 编辑  
function updateLearnTeach({ token, editLife }) {
  let fd = new FormData();
  let params = JSON.stringify(editLife);
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/admin/learnTeach/info/updateLearnTeach",
    method: "POST",
    data: fd,
  });
};
// 学习教育 - 上传视频 /controller/uploadVotePic/info/uploadLearnTeach
function uploadLearnTeach(file) {
  let fd = new FormData()
  // fd.append("token", token)
  fd.append('file', file)
  return request({
    url: "/controller/uploadVotePic/info/uploadLearnTeach",
    method: "POST",
    data: fd
  });
};
// 大数据 投诉建议列表
function getComplaintsList(file) {
  let fd = new FormData()
  fd.append("token", token)
  return request({
    url: "/admin/statistics/info/complaintsList",
    method: "POST",
    data: fd
  });
}


export {
  findPartyPublicity, findPartyPublicityById, insertPartyPublicity, deletePartyPublicity, updatePartyPublicity, auditPartyPublicity, findPublicityWayStatistics,
  findPositions, findPositionsById, deletePositions, auditPositions, insertPosition, updatePositions, findPositionsByAddress, OrgTreelist,
  findOrgLife, insertOrgLife, uploadOrgLife, deleteOrgLife, findOrgLifeById, auditOrgLife, updateOrgLife, findOrgLifeStatistics, findMeetingStatistics, deleteOrgLifePerson,
  findLearnTeach, deleteLearnTeach, insertLearnTeach, findLearnTeachById, updateLearnTeach, uploadLearnTeach,getComplaintsList
};